import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-icons/font/bootstrap-icons.scss';

import './index.less';

import * as _ from "lodash";
import React from 'react';
import {createRoot} from 'react-dom/client';
import {HashRouter as Router, Routes, Route} from 'react-router-dom';

import { loadDictionaries } from './stores/Dictionaries.jsx';
import { loadState } from './stores/State.jsx';

import StatusApp from './apps/Status/index.jsx';
import CheckStepApp from './apps/Check/index.jsx';
import MainApp from './apps/Main/index.jsx';


if(window.trit === 'undefined') window.trit = {};


console.log("[X] Loading dictionaries...");
loadDictionaries('dictionaries.json')
    .then(() => loadState(true))
    .then(() => {
        window.preloader('hide');
    })
    .catch((err) => {
        window.preloader('error');
        console.error(err);
    })


const mainRouter = (
    <Router>
        <Routes>
            <Route path="/check_and_send" element=<CheckStepApp /> />
            <Route path="/status/:statementId" element=<StatusApp /> />
            <Route path="/*" element=<MainApp /> />
        </Routes>
    </Router>
);

createRoot(document.getElementById('content')).render(mainRouter);
